import { adminAPIService } from './index'

const route = 'home-configs'

export default {
  getInstoryList: () => {
    return adminAPIService({
      url: `${route}/instories`,
      method: 'get',
    })
  },
  updateInstories: (list) => {
    const body = `json=${encodeURIComponent(JSON.stringify(list))}`
    return adminAPIService({
      url: `${route}/instories`,
      method: 'post',
      data: body,
    })
  },
  getInstoryItemList: (id) => {
    return adminAPIService({
      url: `${route}/instories/${id}`,
      method: 'get',
    })
  },
  updateInstoryItems: (id, list) => {
    const body = `json=${encodeURIComponent(JSON.stringify(list))}`
    return adminAPIService({
      url: `${route}/instories/${id}`,
      method: 'post',
      data: body,
    })
  },
  getHelloBarList: () => {
    return adminAPIService({
      url: `${route}/hello-bars`,
      method: 'get',
    })
  },
  getHelloBarDetail(id) {
    return adminAPIService({
      url: `${route}/hello-bars/${id}`,
      method: 'get',
    })
  },
  createHelloBar(detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/hello-bars`,
      method: 'post',
      data: body,
    })
  },
  updateHelloBar(id, detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/hello-bars/${id}`,
      method: 'post',
      data: body,
    })
  },
  deleteHelloBar(id) {
    return adminAPIService({
      url: `${route}/hello-bars/${id}`,
      method: 'delete',
    })
  },
  getHomepageTakeoverDetail: () => {
    return adminAPIService({
      url: `${route}/homepage-takeover`,
      method: 'get',
    })
  },
  updateHomepageTakeover(detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/homepage-takeover`,
      method: 'post',
      data: body,
    })
  },
}
